<template>
	<div class="directory">
		<h2 class="serif uppercase">Category</h2>
		<ul>
			<li v-for="category in categories" :class="{ active: selected == category.value }" class="uppercase">
				<a @click.prevent="selectCategory(category.value)">
					{{ category.text }}
				</a>
			</li>
		</ul>
	</div>
</template>

<script>
	export default {
		props: [ 'selected', 'categories' ],
		methods: {
			selectCategory: function (category) {
				this.selected = category;
			}
		}
	}
</script>



/** WEBPACK FOOTER **
 ** CategorySelector.vue?35e54761
 **/